import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";
import { PuntoGeograficoSchema } from "./PuntoGeograficoSchema";

export const TomaAguaSuperficialSchema = yup.object().shape({
  orden: yup.number().required("errors.tomaAguaSuperficial.orden.required"),
  caudalMedio: CantidadSchema.typeError(
    "errors.tomaAguaSuperficial.caudalMedio.type",
  )
    .required("errors.tomaAguaSuperficial.caudalMedio.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3DIA" } }),
  caudalPico: CantidadSchema.typeError(
    "errors.tomaAguaSuperficial.CaudalPico.type",
  )
    .required("errors.tomaAguaSuperficial.caudalPico.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3H" } }),
  ubicacion: PuntoGeograficoSchema.required(
    "errors.tomaAguaSuperficial.ubicacion.required",
  ).default(PuntoGeograficoSchema.cast(undefined, { assert: false })),
  subcuenca: yup
    .object()
    .typeError("errors.tomaAguaSuperficial.subcuenca.type")
    .required("errors.tomaAguaSuperficial.subcuenca.required")
    .default(null),
  caudalimetroFunciona: yup
    .boolean()
    .required("errors.tomaAguaSuperficial.caudalimetroFuncion.required")
    .default(false),
});
